export enum TNCSignalTypeEnum {

  KILL,
  RESTART,
  UPDATE
}
